<template>
  <div class="wrap">
    <div class="top">
      <p class="tit">SD-Wallet</p>
      <p class="desc">Best time,best econology</p>
      <img v-show="imgcn" src="../assets/images/download/phone-cn.png" alt class="img-2" />
      <img v-show="imgen" src="../assets/images/download/phone-en.png" alt class="img-2" />
      <img v-show="imgft" src="../assets/images/download/phone-ft.png" alt class="img-2" />
    </div>
    <div class="bottom">
      <div class="row-1">
        <a href="https://testflight.apple.com/join/sgEQEwiL">
          <i class="iconfont icon-ios-2"></i>iOS {{$t('download.down')}}
        </a>
      </div>
      <div class="row-2">
        <a href="https://static.sdchain.io/files/apk/sdchain_release.apk">
          <i class="iconfont icon-anzhuo"></i>Android {{$t('download.down')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "download",
  data() {
    return {
      imgcn: false,
      imgen: false,
      imgft: false
    };
  },
  created() {
    this.getImg();
  },
  methods: {
    getImg() {
      if (localStorage.Lang == "cn") {
        this.imgcn = true;
      } else if (localStorage.Lang == "tw") {
        this.imgft = true;
      } else {
        this.imgen = true;
      }
    }
  }
};
</script>

<style scoped>
.wrap {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  background-color: #fff;
  /* position: relative; */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.top {
  width: 100%;
  height: calc(100vh - 140px);
  background-image: url("../assets/images/download/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* overflow: hidden; */
  position: relative;
}
.top .tit {
  font-size: 36px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  padding-top: 50px;
}
.top .desc {
  font-size: 22px;
  font-weight: 400;
  color: rgba(255, 255, 254, 1);
  text-align: center;
  margin-top: 20px;
}
.top .img-2 {
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: block;
  bottom: 0;
  position: absolute;
}
.bottom {
  height: 140px;

  background-color: #fff;
  /* overflow: hidden; */
}
.bottom .row-1 {

  text-align: center;
  width: 75%;
  margin: 0 auto;
}
.bottom .row-1 a {
  display: block;
  width: 100%;
  padding: 10px 0px;
  font-size: 18px;
  color: #fff;
  background: rgba(76, 143, 255, 1);
  border-radius: 70px;
}
.bottom .row-1 a i {
  color: #fff;
  padding-right: 10px;
  font-size: 20px;
}

.bottom .row-2 {
  margin-top: 30px !important;
  text-align: center;
  width: 75%;
  margin: 0 auto;
}
.bottom .row-2 a {
  display: block;
  width: 100%;
  padding: 10px 0px;
  font-size: 18px;
  color: #fff;
  background: rgba(57, 99, 234, 1);
  border-radius: 70px;
}
.bottom .row-2 a i {
  color: #fff;
  padding-right: 10px;
  font-size: 20px;
}
</style>
